module.exports = __webpack_public_path__ + "static/media/MyPalate.5474b294.png";